import keycloakAxios from '@/services/axios';
import {Company} from '@/types/company';
import {store} from '@/redux-store/store';
import {setCompanyData} from '@/redux-store/slices/company';
import {updateCompanyinRedux} from '@/redux-store/slices/admin/companies';

export const updateCompanyData = (
  updatedValues: Company,
  companyId: string
) => {
  let endpoint = 'company/update';

  if (companyId) {
    endpoint = `company/${companyId}/update`;
  }

  return keycloakAxios.post(endpoint, updatedValues, {}).then((response) => {
    if (response.status >= 300) {
      throw new Error(
        `Error updating company data: Invalid status code: ${response.status}`
      );
    }
    store.dispatch(updateCompanyinRedux({company: response.data}));

    if (response.data._id === store.getState().company.company._id) {
      store.dispatch(setCompanyData(response.data));
    }
    return response.data;
  });
};
